export enum HealthEntityType {
    speciality = 'speciality',
    insurance = 'insurance',
    procedure = 'procedure',
    organizationUnit = 'organizationUnit',
    doctor = 'doctor',
    appointmentType = 'appointmentType',
    insurancePlan = 'insurancePlan',
    insuranceSubPlan = 'insuranceSubPlan',
    planCategory = 'planCategory',
    group = 'group',
    occupationArea = 'occupationArea',
    organizationUnitLocation = 'organizationUnitLocation',
    typeOfService = 'typeOfService',
    reason = 'reason',
}

export enum HealthIntegrationSynchronizeStatus {
    error = 0,
    synchronizing = 1,
    synced = 2,
}

export enum HealthEntitySource {
    erp = 0,
    user = 1,
    api = 2,
    default = 3,
}